var _class, _descriptor, _TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { and } from 'ember-truth-helpers';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { ModelListItem } from 'core/components/model-list';
import FollowUpReason from 'core/models/follow-up-reason';
import Protocol, { TreatmentProtocol } from 'core/models/protocol';
import { Changeset, EmberChangeset } from 'ember-changeset';
import * as ProtocolSections from './protocol-sections';
import { classify } from '@ember/string';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent = (_class = (_TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent = class TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent extends Component {
  constructor(owner1, args1) {
    super(owner1, args1);
    _initializerDefineProperty(this, "router", _descriptor, this);
    /**
    * The local changeset created for this specific item.
    * It should be executed and then set as dirty to propagate changes into the main changeset
    **/
    _defineProperty(this, "localChangeset", void 0);
    _defineProperty(this, "protocolModel", void 0);
    this.localChangeset = Changeset(args1.item.item);
    this.protocolModel = Protocol.new(this.localChangeset.data);
  }
  get protocolComponent() {
    return ProtocolSections[classify(this.protocol)];
  }
  get preTreatmentSynthesisRoute() {
    if (this.patientId && this.treatmentId && this.protocolUuid) {
      return this.router.urlFor('medics-web.protected.patients.patient.pre-treatment-synthesis', this.patientId, {
        queryParams: {
          treatmentId: this.treatmentId,
          protocolUuid: this.protocolUuid
        }
      });
    }
    return undefined;
  }
  get hasProtocol() {
    return Boolean(this.protocol);
  }
  get patientId() {
    return this.args.changeset.get('patient')?.id;
  }
  get treatmentId() {
    return this.args.changeset.get('id');
  }
  get protocolUuid() {
    return this.localChangeset.get('uuid');
  }
  get protocol() {
    return this.localChangeset.get('protocol');
  }
  get protocols() {
    return this.args.changeset.get('protocols');
  }
  onChangesetUpdate(changeset1) {
    changeset1.execute();
    this.setAsDirty();
  }
  resumeProtocol() {
    this.localChangeset.set('pause-date', null);
    this.localChangeset.set('pause-time-frequency-value', null);
    this.localChangeset.set('pause-time-frequency-unit', null);
    this.localChangeset.set('paused', false);
    this.localChangeset.execute();
    this.setAsDirty();
  }
  setAsDirty() {
    this.args.changeset.set('protocols', [].concat(this.protocols));
  }
}, setComponentTemplate(precompileTemplate("\n    <div class=\"mb-6\">\n      {{#if (and this.hasProtocol this.protocolComponent)}}\n        <this.protocolComponent @changeset={{this.localChangeset}} @onChangesetUpdate={{this.onChangesetUpdate}} @followUpReasonId={{@followUpReasonId}} @item={{@item}} @protocolModel={{this.protocolModel}} @preTreatmentSynthesisRoute={{this.preTreatmentSynthesisRoute}} @resumeProtocol={{this.resumeProtocol}} />\n      {{/if}}\n    </div>\n  ", {
  strictMode: true,
  scope: () => ({
    and
  })
}), _TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent), _TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onChangesetUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangesetUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resumeProtocol", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resumeProtocol"), _class.prototype), _class);
export { TreatmentHistoryEditionFormProtocolsViewBaseProtocolItemComponent as default };